import { render, staticRenderFns } from "./skillsModal.vue?vue&type=template&id=6d3971a6&"
import script from "./skillsModal.vue?vue&type=script&lang=js&"
export * from "./skillsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports